class NewSidebarDelegate {
    setActiveItem(item) {
        this.setState({ activeItem: item });
    }

    setCollapsed(isCollapsed) {
        this.setState({ isCollapsed });
    }
}

export default NewSidebarDelegate;
